import { Grid } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MyTextField
} from "../../Lib/componentLibrarys";
import { useEffect, useState } from "react";
import Api from "../../../api2";

export const FormNhap = ({ values, errors, setFieldValue, linhVucList }) => {
  const [appList, setAppList] = useState([]);
  const [nhomChucNangList, setNhomChucNangList] = useState([]);

  const getApiListApp = (idlinhvuc, page, size) => {
    new Api()
      .GetAppByIdLinhVuc({ idlinhvuc: idlinhvuc, page: page || 1, size: size || 100 })
      .then(data => {
        if (data.code === 200) {
          setAppList(data?.data?.result?.data);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };

  const getApiListNhomChucNang = (appId) => {
    new Api()
      .GetListModule({ appId: appId })
      .then(data => {
        if (data.code === 200) {
          setNhomChucNangList(data?.data?.records);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <MySelect
            required
            label="Lĩnh vực:"
            placeholder="Chọn..."
            value={values?.linhVuc}
            options={linhVucList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`linhVuc`, value);
            }}
            errors={errors?.linhVuc}
            helperText={errors?.linhVuc}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            required
            label="Ứng dụng:"
            placeholder="Chọn..."
            value={values?.app}
            options={appList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`app`, value);
            }}
            errors={errors?.app}
            helperText={errors?.app}
            onOpen={() => {
              values?.linhVuc?.id &&
              getApiListApp(values.linhVuc.id, 1, 100);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            required
            label="Nhóm chức năng:"
            placeholder="Chọn..."
            value={values?.module}
            options={nhomChucNangList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`module`, value);
            }}
            errors={errors?.module}
            helperText={errors?.module}
            onOpen={() => {
              values?.app?.id &&
              getApiListNhomChucNang(values.app.id);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="maChucNang">
            {({ field }) => (
              <MyTextField
                required
                label="Mã chức năng:"
                placeholder="Nhập..."
                errors={errors?.maChucNang}
                helperText={errors?.maChucNang}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="name">
            {({ field }) => (
              <MyTextField
                required
                label="Tên chức năng:"
                placeholder="Nhập..."
                errors={errors?.name}
                helperText={errors?.name}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="description">
            {({ field }) => (
              <MyTextField
                label="Mô tả:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};

export const FormNhapUpdate = ({ values, errors, setFieldValue, nhomChucNangList }) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <MySelect
            required
            label="Nhóm chức năng:"
            placeholder="Chọn..."
            value={values?.module}
            options={nhomChucNangList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`module`, value);
            }}
            errors={errors?.module}
            helperText={errors?.module}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="maChucNang">
            {({ field }) => (
              <MyTextField
                required
                label="Mã chức năng:"
                placeholder="Nhập..."
                errors={errors?.maChucNang}
                helperText={errors?.maChucNang}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="name">
            {({ field }) => (
              <MyTextField
                required
                label="Tên chức năng:"
                placeholder="Nhập..."
                errors={errors?.name}
                helperText={errors?.name}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="description">
            {({ field }) => (
              <MyTextField
                label="Mô tả:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};